import React, { useState } from "react"
import CircularHeaderLoader from "../shared/Header/User/CircularHeaderLoader"
import { ChevronDown, ChevronUp } from "../normalizer"

const months = ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun",
                "Jul", "Ago", "Set", "Out", "Nov", "Dez"]

const ObjectiveCard = ({ objective, campaign }) => {
  const [expanded, setExpanded] = useState(false)

  const normalizedPercentage = Number(objective.percentage)
  const normalizedExpectedPercentage = Number(objective.expected_percentage)
  const totalPercentage = normalizedPercentage > 100 ? 100 : normalizedPercentage

  const endDate = new Date(objective.end_date)
  const dateLabel = `Até ${endDate.getDate()} ${months[endDate.getMonth()]}.`

  const hasRules = objective.rules && objective.rules.length > 0

  return (
    <div className="objectives-card">
      <div className="objectives-card-main">
        <CircularHeaderLoader
          campaign={campaign}
          progress={totalPercentage}
          expected_progress={normalizedExpectedPercentage}
          id={objective.id}
        >
          <div className="objectives-card-percentage">
            {normalizedPercentage.toFixed(0)}<span className="sign">%</span>
          </div>
        </CircularHeaderLoader>

        <div className="objectives-card-content">
          <div className="objectives-card-title">{objective.name}</div>
          {objective.description && (
            <div className="objectives-card-description"
                 dangerouslySetInnerHTML={{ __html: objective.description }} />
          )}
          <div className="objectives-card-date-container">
            <span className="objectives-card-date">{dateLabel}</span>
          </div>
          
        </div>

        {hasRules && (
          <button
            className="objectives-card-toggle"
            onClick={() => setExpanded(!expanded)}
          >
            {expanded ? "Ocultar detalhes" : "Ver detalhes"}
            {expanded ? <ChevronUp /> : <ChevronDown />}
          </button>
        )}
      </div>

      {expanded && hasRules && (
        <div className="objectives-card-details">
          {objective.rules.map(rule => {
            const rulePct = Number(rule.percentage)
            const ruleTotal = rulePct > 100 ? 100 : rulePct
            return (
              <div key={rule.id} className="objectives-card-rule">
                <CircularHeaderLoader
                  campaign={campaign}
                  progress={ruleTotal}
                  expected_progress={0}
                  id={`rule-${rule.id}`}
                  radius={32}
                  stroke={4}
                >
                  <div className="objectives-card-rule-percentage">
                    {rulePct.toFixed(0)}<span className="sign">%</span>
                  </div>
                </CircularHeaderLoader>
                <div className="objectives-card-rule-content">
                  <div className="objectives-card-rule-name">{rule.name}</div>
                  <div className="objectives-card-rule-progress">
                    {rule.progress}/{rule.target} concluído
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}

export default ObjectiveCard